import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Form, InputNumber, Col } from 'antd';

function NumberField({
  data,
  index,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'number-input-column', className);

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper'}
        initialValue={data?.value}
        rules={[
          {
            type: 'number',
            message: 'Champs obligatoire, seulement pour le nombre',
            validateTrigger: 'onSubmit',
          },
          {
            required: data?.required || false,
            message: 'Champs obligatoire',
            validateTrigger: 'onSubmit',
          },
        ]}
      >
        <InputNumber
          placeholder={data?.label}
          style={{ width: '100%' }}
        />
      </Form.Item>
    </Col>
  );
};

NumberField.defaultProps = {
  index: 1,
};

NumberField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(NumberField);